import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Syed Hamza Ovais',
    title: "Software Developer",
    desciption:"The system wasn't failing—it was being tested. Under extreme load and rising complexity, he didn't crash or retreat. He optimized, executed, and proved that resilience isn't programmed—it's built.",
    image: 'https://raw.githubusercontent.com/shamzaovais/my-portfolio/refs/heads/main/src/assets/png/unnamed%20(2).png',
    resumePdf: resume
}
